@charset "UTF-8";

/* app/js/src/components/common/visual-filter/visual-filter.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.form::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.form::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.form::-webkit-scrollbar-corner {
  background: transparent;
}
.form::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.form::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.form::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.form::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.form::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
:host {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}
::ng-deep .mat-form-field-appearance-outline .mat-form-field-outline {
  border-radius: 6px;
  border-color: rgba(0, 0, 0, 0.14);
  background: #fff;
  color: rgba(0, 0, 0, 0.85);
  font-feature-settings: "clig" off, "liga" off;
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
::ng-deep .mat-form-field-appearance-outline .mat-form-field-infix {
  padding: 0.75em 0 1em 0;
}
.form {
  height: 210px;
  padding-left: 12px;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}
.form > *:after {
  content: "\2500";
  position: absolute;
  font-family: emoji;
  top: 28px;
  left: -11px;
  height: 102%;
  width: 1px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  background-color: rgba(0, 0, 0, 0.85);
  line-height: 1px;
}
.form > button:after {
  height: 0;
  left: -0.85rem;
  top: 20px;
}
.form .filter-row {
  display: flex;
  align-items: baseline;
  gap: 10px;
  position: relative;
}
.form .filter-row mat-form-field {
  position: relative;
}
.form .filter-row mat-form-field:not([hidden]):not(:last-of-type):after {
  content: "";
  background: rgba(0, 0, 0, 0.85);
  width: 1px;
  height: 9.5px;
  position: absolute;
  right: -5.5px;
  top: 23.5px;
  transform: rotate(90deg);
}
.form .add {
  display: flex;
  margin-top: 8px;
  align-self: baseline;
  padding: 9px 16px 9px 9px;
  align-items: center;
  cursor: pointer;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid #2dbbfc;
  color: #2dbbfc;
  position: relative;
}
.form .add span {
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  text-transform: uppercase;
}
/*# sourceMappingURL=visual-filter.component.css.map */
